import React from "react"

import { ApiResponse } from "shared/types/ApiResponse"
import { ProductPosition } from "shared/types/ProductPosition"
import { WithClassName } from "shared/types/WithClassName"

import { FilteredProductPositionMultiActionHandlers } from "entities/product-positions/model/useProductPositionMultiActionHandlers"
import { MultiEditProductPositionFormData } from "widgets/multi-edit-product-position-form/MultiEditProductPositionForm"
import { MultiEditProductPositionFormOptions } from "widgets/multi-edit-product-position-form/ui/MultiEditProductPositionFormView"

import { ProductPositionMultiSelectSidebarView } from "./ProductPositionMultiSelectSidebarView"
import { useProductPositionMultiSelectSidebarViewModel } from "./hooks/useProductPositionMultiSelectSidebarViewModel"

export interface ProductPositionMultiSelectSidebarModel {
  projectID: string
  productPositions: ProductPosition[]
  callbacks: FilteredProductPositionMultiActionHandlers
  isDisabled: boolean
  onSubmit: (
    formData: MultiEditProductPositionFormData
  ) => Promise<ApiResponse<unknown>> | void

  hideControls?: boolean
}

export interface ProductPositionMultiSelectSidebarProps
  extends ProductPositionMultiSelectSidebarModel,
    WithClassName {
  canEdit?: boolean
  formOptions?: MultiEditProductPositionFormOptions
}

export const ProductPositionMultiSelectSidebar = React.memo(
  (props: ProductPositionMultiSelectSidebarProps) => (
    <ProductPositionMultiSelectSidebarView
      {...useProductPositionMultiSelectSidebarViewModel(props)}
    />
  )
)
